module.exports = __webpack_public_path__ + "6815746f6cc09d4620a1f74dba72b76c.svg";